import { ReactElement, useMemo, useState } from 'react';

import { CalendarPreview } from 'features/calendar';
import { CreateFileModal } from 'features/documents/components/CreateFileModal';
import { EmployeeListPreview } from 'features/employeesPreview';
import { KpiPreview } from 'features/kpi';
import { VisionPreview } from 'features/kpi/containers/VisionPreview';
import { PinnedPostPreview } from 'features/pinnedPost';
import { PostsList } from 'features/postsList';
import { QuickLinksPreview } from 'features/quickLinks';
import { OtherResources } from 'features/resources/components';
import { TasksPreview } from 'features/tasks';
import { MobileTabsValues } from 'features/we/components/types';
import { useSessionState } from 'hooks';
import { Links } from 'settings';

import { Banners, CreatePostActionBar, MobileTabs } from '../../components';
import { useWePageLogic } from './hooks';
import {
  ColumnsW,
  ContentInner,
  DesktopView,
  LeftColumn,
  MobileView,
  PageContent,
  PageW,
  RightColumn,
} from './styled';

export function WePage(): ReactElement {
  const [activeTab, setActiveTab] = useSessionState<MobileTabsValues>(
    'we:activeTab',
    MobileTabsValues.LATEST_UPDATES,
  );
  const { isUsersListLoading, usersList } = useWePageLogic();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const mobileContent = useMemo((): ReactElement => {
    switch (activeTab) {
      case MobileTabsValues.OUR_VISION:
        return <VisionPreview />;
      case MobileTabsValues.COMPANY_INFO:
        return <OtherResources />;
      case MobileTabsValues.OUR_KPI_TARGET:
        return <KpiPreview />;
      case MobileTabsValues.OUR_TEAM:
        return (
          <EmployeeListPreview
            isUsersListLoading={isUsersListLoading}
            usersList={usersList}
            linkInviteEmployee={Links.we.employees.invite}
            linkOfListEmployees={Links.we.employees.index}
          />
        );
      case MobileTabsValues.MY_SCHEDULE:
        return <CalendarPreview />;
      case MobileTabsValues.MY_TASK:
        return <TasksPreview />;
      case MobileTabsValues.MY_PINNED_POSTS:
        return <PinnedPostPreview />;
      case MobileTabsValues.MY_QUICK_LINKS:
        return <QuickLinksPreview />;
      default:
        return <PostsList isMobilePreview />;
    }
  }, [activeTab, isUsersListLoading, usersList]);

  return (
    <PageW>
      <DesktopView>
        <PageContent>
          <ContentInner>
            <Banners />

            <CreatePostActionBar setIsCreateModalOpen={setIsCreateModalOpen} />
            <ColumnsW>
              <LeftColumn>
                <PostsList />
              </LeftColumn>

              <RightColumn>
                <VisionPreview />
                <OtherResources />
                <KpiPreview />
                <EmployeeListPreview
                  isUsersListLoading={isUsersListLoading}
                  usersList={usersList}
                  linkInviteEmployee={Links.we.employees.invite}
                  linkOfListEmployees={Links.we.employees.index}
                />
                <CalendarPreview />
                <TasksPreview />
                {/* <PinnedPostPreview /> */}
                <QuickLinksPreview />
              </RightColumn>
            </ColumnsW>
          </ContentInner>
        </PageContent>
      </DesktopView>

      <MobileView>
        <Banners />
        <LeftColumn>
          <CreatePostActionBar setIsCreateModalOpen={setIsCreateModalOpen} />
          <MobileTabs activeTab={activeTab} onChangeActiveTab={setActiveTab} />
          {mobileContent}
        </LeftColumn>
      </MobileView>
      {isCreateModalOpen && (
        <CreateFileModal
          open={isCreateModalOpen}
          onClose={() => setIsCreateModalOpen(false)}
          categoryId=""
          folderId=""
        />
      )}
    </PageW>
  );
}
